export default __webpack_public_path__ + "static/media/facebook.7baf87f8.svg";